/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileLarge } from "./_background/background-file-large.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FilePresentationLarge = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--large",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "large" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 160,
      height: 160,
      className: cls,
      "data-testid": "FilePresentationLarge",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileLarge, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M41.534 36.212a.727.727 0 0 1-.727-.727V22.73c0-.406.333-.736.739-.719l.168.009c7.14.449 12.852 6.168 13.288 13.312l.008.143a.714.714 0 0 1-.72.739H41.535ZM36.502 25.57c.41-.013.75.316.75.727V39.04c0 .401.325.727.727.727h12.745c.41 0 .74.34.727.75l-.005.15c-.464 7.435-6.642 13.322-14.194 13.322-7.855 0-14.223-6.367-14.223-14.222 0-7.557 5.894-13.738 13.336-14.195l.137-.004Z",
        fill: "#3BA0F3"
      }
    )
  );
};
export {
  FilePresentationLarge
};
